import { url } from './url.js';
import { PESTS, STEDEN } from './data.js';
import { IconPhone, IconMail, IconShield } from './icons.jsx';

export function Footer() {
  // Alle 15 plagen in de footer voor optimale interne linking + PageRank-flow.
  const topPlagen = PESTS;
  // Top-4 grootste steden per provincie — eerder pakte slice(0,12) per ongeluk
  // alleen Zuid-Holland (eerste 12 in array). Nu gebalanceerd zodat alle drie
  // werkgebieden zichtbaar zijn (incl. Amsterdam en Utrecht).
  const topPerProvincie = 4;
  const topStedenPerProv = [
    { provincie: "Zuid-Holland",  steden: STEDEN.filter(s => s.primary && s.provincie === "Zuid-Holland").slice(0, topPerProvincie) },
    { provincie: "Noord-Holland", steden: STEDEN.filter(s => s.primary && s.provincie === "Noord-Holland").slice(0, topPerProvincie) },
    { provincie: "Utrecht",       steden: STEDEN.filter(s => s.primary && s.provincie === "Utrecht").slice(0, topPerProvincie) },
  ];
  const provincies = [
    { naam: "Zuid-Holland",  steden: STEDEN.filter(s => s.provincie === "Zuid-Holland") },
    { naam: "Noord-Holland", steden: STEDEN.filter(s => s.provincie === "Noord-Holland") },
    { naam: "Utrecht",       steden: STEDEN.filter(s => s.provincie === "Utrecht") },
  ];
  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-mark">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2 L 4 6 L 4 12 C 4 17.5 7.5 21 12 22 C 16.5 21 20 17.5 20 12 L 20 6 Z M 12 6.5 L 16 8.5 V 12 C 16 14.8 14.3 16.8 12 17.5 C 9.7 16.8 8 14.8 8 12 V 8.5 Z" fill="white"/>
                </svg>
              </div>
              <span>ABC <span className="accent">Ongedierte</span></span>
            </div>
            <p>
              Professionele ongediertebestrijding voor particulier en zakelijk in
              Zuid-Holland, Noord-Holland en Utrecht. Snel, veilig en vakkundig.
            </p>
            <div className="footer-trust">
              <span><IconShield width="12" height="12" /> Gecertificeerde partners</span>
              <span><IconShield width="12" height="12" /> Vaste prijs vooraf</span>
            </div>
          </div>
          <div>
            <h4>Diensten</h4>
            {/* 2-koloms layout: 15 plagen + spoedservice = 16 items past niet
                meer netjes in 1 column. Per kolom 8 items — visueel rustiger. */}
            <ul style={{ columns: 2, columnGap: 24 }}>
              {topPlagen.map(p => (
                <li key={p.slug}><a href={url.plaag(p.slug)}>{p.nl} bestrijden</a></li>
              ))}
              <li><a href={url.spoed()}>24/7 Spoedservice</a></li>
            </ul>
          </div>
          <div>
            <h4>Werkgebied</h4>
            {/* Per-provincie geörganiseerd zodat alle drie regio's (ZH/NH/UT)
                meteen zichtbaar zijn met de grootste 4 steden — was eerder
                alleen ZH door slice(0,12) over de hele steden-array. */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              {topStedenPerProv.map(grp => (
                <div key={grp.provincie}>
                  <div style={{
                    fontSize: '.7rem',
                    fontWeight: 700,
                    color: 'var(--orange)',
                    letterSpacing: '.08em',
                    textTransform: 'uppercase',
                    marginBottom: 6,
                  }}>{grp.provincie}</div>
                  <ul style={{ margin: 0 }}>
                    {grp.steden.map(s => (
                      <li key={s.slug}><a href={url.stad(s.slug)}>{s.naam}</a></li>
                    ))}
                  </ul>
                </div>
              ))}
              {/* Alle-gemeenten link — vooral zichtbaar op mobile, want
                  daar wordt het volledige .footer-cities blok verborgen. */}
              <a href={url.werkgebied()} className="footer-all-cities">
                Bekijk alle 117 gemeenten →
              </a>
            </div>
          </div>
          <div>
            <h4>Bedrijf</h4>
            <ul>
              <li><a href={url.over()}>Over ons</a></li>
              <li><a href={url.reviews()}>Reviews</a></li>
              <li><a href={url.blog()}>Blog &amp; Kennisbank</a></li>
              <li><a href={url.contact()}>Contact</a></li>
              <li><a href={url.offerte()}>Gratis offerte</a></li>
              <li><a href={url.horeca()}>Voor horeca &amp; HACCP</a></li>
              <li><a href={`${url.contact()}#partner-worden`}>Word partner</a></li>
            </ul>
            <div className="fci" style={{ marginTop: 14 }}>
              <IconPhone /><a href="tel:0855005050">085 500 50 50</a>
            </div>
            <div className="fci">
              <IconMail /><a href="mailto:info@abcongedierte.nl">info@abcongedierte.nl</a>
            </div>
            <div className="fci" style={{ alignItems: 'flex-start', lineHeight: 1.4 }}>
              <span style={{ color: 'var(--orange)', fontSize: '1rem', marginTop: 2 }}>✌</span>
              <span>Fuchsiastraat 55<br/>2565 PL Den Haag</span>
            </div>
          </div>
        </div>

        {/* Volledig werkgebied — alle 117 gemeenten als interne links per provincie.
            Verspreidt PageRank gelijkmatig over álle stadpagina's en bewijst de
            werkgebied-claim feitelijk aan Google. Concurrenten doen dit ook.
            Mobile-audit fase 3: dit blok wordt CSS-hidden op <1024px omdat
            2000+ chars link-soep op mobile een mis-tap-mijnenveld is. De
            top-4 per provincie (footer-grid 'Werkgebied') blijft wel
            zichtbaar, plus de 'Bekijk alle gemeenten' link daar. */}
        <div className="footer-cities" style={{
          marginTop: 32, paddingTop: 24,
          borderTop: '1px solid rgba(255,255,255,0.08)',
        }}>
          <h4 style={{ fontSize: '.78rem', letterSpacing: '.08em', textTransform: 'uppercase', color: 'rgba(255,255,255,.55)', marginBottom: 16 }}>
            Werkgebied, 117 gemeenten in Zuid-Holland, Noord-Holland &amp; Utrecht
          </h4>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: 20 }}>
            {provincies.map(prov => (
              <div key={prov.naam}>
                <div style={{ fontSize: '.72rem', fontWeight: 700, color: 'var(--orange)', letterSpacing: '.06em', textTransform: 'uppercase', marginBottom: 8 }}>
                  {prov.naam} · {prov.steden.length}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 10px', fontSize: '.78rem', lineHeight: 1.6 }}>
                  {prov.steden.map((s, i) => (
                    <span key={s.slug}>
                      <a href={url.stad(s.slug)} style={{ color: 'rgba(255,255,255,.62)', textDecoration: 'none' }}>{s.naam}</a>
                      {i < prov.steden.length - 1 && <span style={{ color: 'rgba(255,255,255,.18)', marginLeft: 6 }}>·</span>}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-bottom" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
          <span>© 2026 ABC Ongediertebestrijding b.v.&nbsp; ·&nbsp; KvK 71298592&nbsp; ·&nbsp; BTW NL002334370B70&nbsp; ·&nbsp; Sinds 2017</span>
          <div className="flinks">
            <a href={url.privacy()}>Privacybeleid</a>
            <a href={url.cookies()}>Cookiebeleid</a>
            <a href={url.voorwaarden()}>Algemene voorwaarden</a>
            <a href="/sitemap.xml">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export function StickyBel() {
  return (
    <a href="tel:0855005050" className="sticky-bel">
      Bel direct: 085 500 50 50
    </a>
  );
}

export function FloatingPhone() {
  // Groen, ronde bel-CTA op élke pagina (mobile + desktop). Tap-to-call —
  // voor de mobiele gebruiker de snelste route naar contact. Hetzelfde
  // signaal als StickyBel onderaan, maar visueel sterker zichtbaar tijdens
  // het scrollen.
  return (
    <a
      href="tel:0855005050"
      className="floating-phone floating-call"
      aria-label="Bel ABC Ongediertebestrijding"
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
      </svg>
      <span className="fp-tooltip">Bel ons direct</span>
    </a>
  );
}


